const ExpiredTrial = () => {
  return (
    <></>
  );
};

export default ExpiredTrial;
